import { useState } from 'react'
import { Button, Stack, Typography } from '@mui/material'
import ClarificationField from './ClarificationField'
import { answerPayload, requiredAnswered } from './clarificationAnswers'

/** The editable card. Stays editable on failure so the typing is never lost. */
export default function ClarificationForm({ questions, pending, error, onSubmit }) {
  const [values, setValues] = useState({})
  const [others, setOthers] = useState({})

  const change = (id, value, other) => {
    setValues((prev) => ({ ...prev, [id]: value }))
    setOthers((prev) => ({ ...prev, [id]: other }))
  }

  return (
    <Stack sx={{ gap: 1.25 }}>
      {questions.map((question) => (
        <ClarificationField
          key={question.id}
          question={question}
          value={values[question.id]}
          otherValue={others[question.id]}
          disabled={pending}
          onChange={change}
        />
      ))}
      <Stack direction="row" sx={{ gap: 1, alignItems: 'center', mt: 0.25 }}>
        <Button
          size="small"
          variant="contained"
          disabled={pending || !requiredAnswered(questions, values, others)}
          onClick={() => onSubmit(answerPayload(questions, values, others))}
        >
          {pending ? 'Sending…' : 'Submit answers'}
        </Button>
        {error ? (
          <Typography sx={{ fontSize: 12, color: 'var(--app-error, #a4262c)' }}>{error}</Typography>
        ) : null}
      </Stack>
    </Stack>
  )
}
